// extracted by mini-css-extract-plugin
export default {"signaturePad":"src-signer-app-signer-signature-document-signature-standalone-field-module__signaturePad--2ComY"};